var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"upload-toast-fade"}},[(_vm.innerShow)?_c('div',{staticClass:"upload-overlay"},[_c('div',{staticClass:"loading-dots"},[_c('span'),_c('span'),_c('span')]),_c('p',[_vm._v(_vm._s(_vm.tipText))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }